import { Injectable } from '@angular/core';

import { RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { RouteStopState } from '../../schedule.model';
import { ScheduleService } from '../../schedule.service';
import { RouteStopsActions } from './route-stops.actions';

@Injectable()
export class RouteStopsEpics implements RidangoEpic {
    constructor(private actions: RouteStopsActions, private service: ScheduleService) {}

    register() {
        return [this.fetchStopsById, this.fetchRoutePolylineById, this.fetchRouteStopDepartures];
    }

    fetchStopsById = (action$: ActionsObservable<any>) =>
        action$.ofType(RouteStopsActions.FETCH_ROUTE_STOPS).pipe(
            switchMap((action: RidangoReduxAction) => {
                const { routeId, directionId } = action.payload;
                return this.service.fetchRouteStopsList(routeId, directionId).pipe(
                    map((response) => this.actions.fetchRouteStopsSuccess(this.normalizeRouteStops(response))),
                    catchError(() => of(this.actions.fetchRouteStopsFail()))
                );
            })
        );

    fetchRoutePolylineById = (action$: ActionsObservable<any>) =>
        action$.ofType(RouteStopsActions.FETCH_ROUTE_POLYLINE).pipe(
            switchMap((action: RidangoReduxAction) => {
                const { routeId, directionId } = action.payload;
                return this.service.fetchRoutePolyline(routeId, directionId).pipe(
                    map((response) => this.actions.fetchRoutePolylineSuccess(response)),
                    catchError(() => of(this.actions.fetchRoutePolylineFail()))
                );
            })
        );

    private normalizeRouteStops(response): RouteStopState {
        const stops: RouteStopState = {
            ids: [],
            entities: {},
        };

        response.forEach((d) => {
            stops.ids.push(d.stop_id);
            stops.entities[d.stop_id] = d;
        });

        return stops;
    }

    fetchRouteStopDepartures = (action$: ActionsObservable<any>) =>
        action$.ofType(RouteStopsActions.FETCH_ROUTE_STOP_DEPATURES).pipe(
            switchMap((action: RidangoReduxAction) => {
                const { routeId, stopId } = action.payload;
                return this.service.fetchRouteStopDeparturesList(routeId, stopId).pipe(
                    map((response) =>
                        this.actions.fetchRouteStopDeparturesSuccess(this.setRouteStopDepartures(response))
                    ),
                    catchError(() => of(this.actions.fetchRouteStopDeparturesFail()))
                );
            })
        );

    private setRouteStopDepartures(response) {
        const departures = {
            schedule: {
                days: Object.keys(response),
                departures: response,
            },
        };

        return departures;
    }
}
